var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1h45v45H1V1Z",
    fill: "#241F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.281 2.281H44.72V44.72H2.281V2.28Z",
    fill: "#FCEE25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5 28.625 13.532 13.532 5.285-5.285L28.785 23.34l2.642-2.642v-5.285l1.922-1.922v4.324l1.842 1.842 6.645-6.646 1.762 1.761c0-1.12-.32-5.044-3.443-8.167-3.603-3.283-7.126-1.281-8.327-.08l-6.406 6.406 1.601 1.601-3.523 3.523-3.523-3.523 1.601-1.601-6.405-6.406c-1.201-1.201-4.724-3.203-8.248.24-3.202 3.043-3.443 6.966-3.443 8.087l1.762-1.761 6.566 6.566 1.841-1.842V13.49l1.922 1.922v5.285l2.642 2.642L4.764 36.712l5.284 5.284L23.5 28.625Z",
    fill: "#241F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg32);
export default __webpack_public_path__ + "static/media/32.6757a609df588b1969c44e1b22493054.svg";
export { ForwardRef as ReactComponent };